module.exports = __webpack_public_path__ + "media/seher_1.0b.0e66b9de.mp3";